import React from "react"
import {
  AppBar,
  Toolbar,
  Box,
  Container,
  useTheme,
  useMediaQuery,
  Breakpoint
} from "@mui/material"
import { useStyles } from "./styles"
import { useElementsResizeListen } from "../../../../../mp-core/hooks"
import { IMPERSONATION_BANNER_ID } from "../../../../../mp-core/Impersonation/containers/ImpersonationBannerContainer"

interface BaseHeaderProps {
  hideDefaultContent?: boolean
  children?: React.ReactNode
}

const BaseHeader: React.FC<React.PropsWithChildren<BaseHeaderProps>> = ({
  hideDefaultContent,
  children
}) => {
  const { classes } = useStyles()

  const theme = useTheme()
  // const mobile = theme.breakpoints.down("xs")
  const mobile = useMediaQuery(theme.breakpoints.down("sm" as Breakpoint))

  const { elementsSizes } = useElementsResizeListen([IMPERSONATION_BANNER_ID])

  return (
    <AppBar
      color="primary"
      position={mobile ? "static" : "sticky"}
      id="topHeader"
      style={{
        zIndex: 1000,
        top: elementsSizes[IMPERSONATION_BANNER_ID]?.height || 0
      }}
    >
      <Box className={classes.rootBox}>
        <Container maxWidth="xl">
          <Toolbar style={{ padding: mobile ? 0 : theme.spacing(0, 4) }}>
            <Box
              display="flex"
              width={1}
              id="topHeaderMainContent"
              alignItems={"inherit"}
              padding={theme.spacing(2, 0)}
              data-automation-id="HeaderContent"
            >
              <Box
                id="headerDefaultContent"
                alignItems="center"
                width={1}
                display={!hideDefaultContent ? "flex" : "none"}
              >
                {children}
              </Box>
            </Box>
          </Toolbar>
        </Container>
      </Box>
    </AppBar>
  )
}

export default BaseHeader
